import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@core/services/auth.service';
import { NotificationService } from '@core/services/notification.service';
import { AuthStatusService } from '@core/services/auth-status.service';
import { AuthorisedSideNavService } from '@app/core/services/authorised-side-nav.service';
import { environment } from '@env/environment';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: [
    './header.component.scss',
    './header_rsp.component.scss'
  ]
})
export class HeaderComponent implements OnInit {
  activeNew = false;
  activeNewSecond = false;
 

  @Input()
  role: string;
  @Input()
  name: string;

  constructor(
    private router: Router,
    private authService: AuthService,
    private authStatusService: AuthStatusService,
    private notificationService: NotificationService,
    public sideNavService: AuthorisedSideNavService
    ) { }

  ngOnInit() {
   
  }

  redirectToScan() {
    if(this.isKioskEnabled()){
      this.router.navigate([`scan-cargo/scan-cargo-guided-init`]);
    }else if(!this.isKioskEnabled() && this.isPiecewiseGuidedEnabled()){
      this.router.navigate([`scan-cargo/scan-cargo-piecewise-init`]);
    }else{
      this.router.navigate([`scan-cargo`]);
    }
    this.activeNewSecond = true;
    this.activeNew = false;
  }

  isKioskEnabled(){
    if(environment.KIOSK_ENABLED && typeof(environment.KIOSK_ENABLED)==="string"){
      return environment.KIOSK_ENABLED.toLowerCase()==="true";
    }
    return false; // hide by default
  }

  isPiecewiseGuidedEnabled(){
    if(environment.PIECEWISE_GUIDED_ENABLED && typeof(environment.PIECEWISE_GUIDED_ENABLED)==="string"){
      return environment.PIECEWISE_GUIDED_ENABLED.toLowerCase()==="true";
    }
    return false;
  }

  isAdmin(){
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    return userDetails && userDetails.roleCode === "admin";
  }

  redirectToDashboard() {
    this.router.navigate([`dashboard`]);
    this.activeNew = true;
    this.activeNewSecond = false;
  }

  logout() {
        localStorage.clear();
        this.authStatusService.setState(false);
        this.router.navigate(['/login']);
    // this.authService.logout().subscribe(
    //   (response: any) => {
    //     localStorage.clear();
    //     this.authStatusService.setState(false);
    //     this.router.navigate(['/login']);
    //   },
    //   error => {
    //     this.notificationService.showError('Logout Error', error.error.response.error);
    //   }
    // );
  }

}
